import {Transportation} from "@Pages/stationToStation/features/companyCard/components/Transportation";
import Row from "@Containers/components/Row";
import Translation from "@Translation/components/Translation";
import IconTimes from "@Icons/controls/IconTimes";
import {Colors} from "@Styles/Colors.style";

interface TravelTableBodyProps {
    parsedData: any;
    setHoveredColumnIndex: (index: number) => void;
    hoveredColumnIndex: number;
}

export const TravelTableBody = (props: TravelTableBodyProps) => {
    const {
        setHoveredColumnIndex,
        hoveredColumnIndex,
        parsedData,
    } = props;

    return (
        <tbody>
            {parsedData.set.map((routeData, index) => {
                return (
                    <tr key={index}>
                        <td className={`travel-table-icons hovered ${index === 0 ? 'hovered__top' : ''} ${index === parsedData.set.length - 1 ? 'hovered__bottom' : ''}`}>
                            <Transportation
                                width={45}
                                height={45}
                                transportType={routeData.transportType}
                            />
                        </td>
                        <td
                            onMouseOver={() => {
                                setHoveredColumnIndex(2)
                            }}
                            className={hoveredColumnIndex === 2 ? `hovered ${index === 0 ? 'hovered__top' : ''} ${index === parsedData.set.length - 1 ? 'hovered__bottom' : ''}` : ''}
                        >
                            {routeData.lowestPrice}
                        </td>
                        <td
                            onMouseOver={() => {
                                setHoveredColumnIndex(3)
                            }}
                            className={hoveredColumnIndex === 3 ? `hovered ${index === 0 ? 'hovered__top' : ''} ${index === parsedData.set.length - 1 ? 'hovered__bottom' : ''}` : ''}
                        >
                            {routeData.averagePrice}
                        </td>
                        <td
                            onMouseOver={() => {
                                setHoveredColumnIndex(4)
                            }}
                            className={hoveredColumnIndex === 4 ? `hovered ${index === 0 ? 'hovered__top' : ''} ${index === parsedData.set.length - 1 ? 'hovered__bottom' : ''}` : ''}
                        >
                            {routeData.numberOfRoutes}
                        </td>
                        <td
                            onMouseOver={() => {
                                setHoveredColumnIndex(5)
                            }}
                            className={hoveredColumnIndex === 5 ? `hovered ${index === 0 ? 'hovered__top' : ''} ${index === parsedData.set.length - 1 ? 'hovered__bottom' : ''}` : ''}
                        >
                            {routeData.earliestDeparture}
                        </td>
                        <td
                            onMouseOver={() => {
                                setHoveredColumnIndex(6)
                            }}
                            className={hoveredColumnIndex === 6 ? `hovered ${index === 0 ? 'hovered__top' : ''} ${index === parsedData.set.length - 1 ? 'hovered__bottom' : ''}` : ''}
                        >
                            {routeData.latestDeparture}
                        </td>
                        <td
                            onMouseOver={() => {
                                setHoveredColumnIndex(7)
                            }}
                            className={hoveredColumnIndex === 7 ? `hovered ${index === 0 ? 'hovered__top' : ''} ${index === parsedData.set.length - 1 ? 'hovered__bottom' : ''}` : ''}
                        >
                            {routeData.averageJourneyDuration}
                        </td>
                        <td
                            onMouseOver={() => {
                                setHoveredColumnIndex(8)
                            }}
                            className={hoveredColumnIndex === 8 ? `hovered ${index === 0 ? 'hovered__top' : ''} ${index === parsedData.set.length - 1 ? 'hovered__bottom' : ''}` : ''}
                        >
                            <span dangerouslySetInnerHTML={{__html: routeData.stationLinks.departureStationLink}}/>
                        </td>
                        <td
                            onMouseOver={() => {
                                setHoveredColumnIndex(9)
                            }}
                            className={hoveredColumnIndex === 9 ? `hovered ${index === 0 ? 'hovered__top' : ''} ${index === parsedData.set.length - 1 ? 'hovered__bottom' : ''}` : ''}
                        >
                            <span dangerouslySetInnerHTML={{__html: routeData.stationLinks.destinationStationLink}}/>
                        </td>
                        <td
                            onMouseOver={() => {
                                setHoveredColumnIndex(10)
                            }}
                            className={hoveredColumnIndex === 10 ? `hovered ${index === 0 ? 'hovered__top' : ''} ${index === parsedData.set.length - 1 ? 'hovered__bottom' : ''}` : ''}
                        >
                            {Array.isArray(routeData.popularOperators) && routeData.popularOperators.length > 0 ? (
                                routeData.popularOperators.map((link, i) => (
                                    <span key={i} dangerouslySetInnerHTML={{__html: link}}/>
                                ))
                            ) : (
                                <p>
                                    {routeData.popularOperators}
                                </p>
                            )}
                        </td>
                        <td
                            onMouseOver={() => {
                                setHoveredColumnIndex(11)
                            }}
                            className={hoveredColumnIndex === 11 ? `hovered ${index === 0 ? 'hovered__top' : ''} ${index === parsedData.set.length - 1 ? 'hovered__bottom' : ''}` : ''}
                        >
                            <Row center className="travel-table-combined">
                                {routeData.combinedTransport ? (
                                    <Translation translationKey="sys.yes"/>
                                ) : (
                                    <>
                                        <IconTimes fill={Colors.primaryColor}/>
                                        <Translation translationKey="sys.no"/>
                                    </>
                                )}
                            </Row>
                        </td>
                    </tr>
                )
            })}
        </tbody>
    )
}